export const ESexType = {
  Woman: 0,

  Man: 1,
} as const

export type ESexType = (typeof ESexType)[keyof typeof ESexType]
